/**
 * @generated SignedSource<<96746e79890fac108fd0f2fde742b40f>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Jun0SettingsPage_query$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PageWithBreadCrumbs_query">;
  readonly " $fragmentType": "Jun0SettingsPage_query";
};
export type Jun0SettingsPage_query$key = {
  readonly " $data"?: Jun0SettingsPage_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"Jun0SettingsPage_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Jun0SettingsPage_query",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PageWithBreadCrumbs_query"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "78d62acf939359d96a8b334679b3cb49";

export default node;
